import { axios } from '../../../lib'
import { useQueryClient, useMutation } from 'react-query'
import { toast } from 'react-toastify'
import { useNavigate } from 'react-router-dom'

const createCustomer = (data: any): Promise<any> => {
  return axios.post(`customers`, data)
}

export function useCreateCustomer() {
  const queryClient = useQueryClient()
  const navigate = useNavigate()

  return useMutation(createCustomer, {
    onSuccess: () => {
      queryClient.invalidateQueries('customers')
      toast.success('Cliente cadasrado com sucesso!')
      navigate('/customers')
    },
    onError: () => {
      queryClient.invalidateQueries('customerAddresses')
      toast.error('Não foi possível cadastrar o cliente')
    }
  })
}
